<script>
  import {Bar, mixins} from 'vue-chartjs'

  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data () {
      return {
        options: {
          layout: {
            padding: {
              top: 20
            }
          },
          elements: {
            point: {
              radius: 0
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              barPercentage: 1,
              gridLines: {
                display: true
              },
              ticks: {
                autoSkipPadding: 50,
                maxRotation: 0
              }
            }],
            yAxes: [{
              display: true,
              gridLines: {
                display: true
              }
            }]
          },
          tooltips: {
            backgroundColor: 'rgba(220, 220, 220, 0.8)',
            bodyFontColor: '#2c2c2c',
            bodySpacing: 5,
            callbacks: {
              title: function (tooltipItem, data) {
                return null
              }
            },
            cornerRadius: 0,
            intersect: false,
            mode: 'label',
            xPadding: 10,
            yPadding: 10
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/charts/ForecastBarChart.vue